import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { ClientiApi } from "../data/apis";
import { useMemo } from "react";

export function useClienteDataSource(personaleId?: number) {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new ClientiApi(apiConfiguration);

        return new CustomStore({
            key: 'idCliente',
            loadMode: 'raw',
            load: (loadOptions) => {
                return api.getClienti({
                    idPersonale: personaleId
                });
            }
        })
    }, [personaleId, apiConfiguration]);

    return dataSource;
}